export default function VideoPlayIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2142 13.1204C16.9762 14.1052 15.8512 14.8012 13.6012 16.1932C11.426 17.5386 10.3386 18.2115 9.46212 17.9411C9.09976 17.8292 8.76962 17.6169 8.50338 17.3243C7.85937 16.6168 7.85938 15.2445 7.85938 12.5C7.85938 9.75549 7.85937 8.38314 8.50338 7.67563C8.76962 7.38313 9.09976 7.17078 9.46212 7.05897C10.3386 6.78855 11.426 7.46132 13.6012 8.80682C15.8512 10.1988 16.9762 10.8948 17.2142 11.8796C17.3124 12.2861 17.3124 12.7139 17.2142 13.1204Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="3.14285"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const displayName = "VideoPlayIcon";
